/**
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "mw-form/PopupMenuItem",
    "MW/toolstrip/mixins/property/TypeMixin",
    "MW/toolstrip/mixins/property/DescriptionOverrideMixin",
    "MW/toolstrip/mixins/property/TextOverrideMixin",
    "MW/toolstrip/mixins/property/MenuIdMixin",
    "MW/toolstrip/mixins/property/IconMixin",
    "MW/toolstrip/mixins/property/IconOverrideMixin",
    "MW/toolstrip/mixins/property/UseQuickAccessIconMixin",
    "mw-form/mixins/mixinDependencyValidator"

], function (declare, PopupMenuItem, TypeMixin, DescriptionOverrideMixin, TextOverrideMixin, MenuIdMixin,
             IconMixin, IconOverrideMixin, UseQuickAccessIconMixin, mixinDependencyValidator) {

    return declare(mixinDependencyValidator.validate([PopupMenuItem, TypeMixin, DescriptionOverrideMixin,
        TextOverrideMixin, MenuIdMixin, IconMixin, IconOverrideMixin, UseQuickAccessIconMixin]), {
        visualFamily: "default"
    });
});
